import type { ComplianceOverviewCounts } from '@chukua/common';
import { useEffect, useState } from 'react';
import { getComplianceOverviewCounts } from '../compliance.api';

export type ComplianceOverviewCountsState = { status: 'loading' } | { status: 'loaded'; counts: ComplianceOverviewCounts } | { status: 'error' };

/** The count tile row above the list — the future dashboard's data, read here first (gitaumoses4/chukua#18). Silently unavailable on error: the list below is the page's real content. */
export function useComplianceOverviewCounts(): ComplianceOverviewCountsState {
  const [state, setState] = useState<ComplianceOverviewCountsState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    getComplianceOverviewCounts()
      .then((counts) => {
        if (!cancelled) setState({ status: 'loaded', counts });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
